@if (showOpeningSizes) {
  <div class="fixed-table-header-container">
    <table cellspacing="0">
      <thead>
        <tr>
          <th>Outer</th>
          <th>Artwork</th>
          <th>Opening</th>
        </tr>
      </thead>
    </table>
    <div class="fixed-table-header-container-inner">
      <table cellspacing="0">
        <tbody>
          @for (size of availableSizes; track size) {
            <tr (click)="selectSize(size)" [ngClass]="{selected: selectedSize == size}">
              <td>{{size.outer | size | inches }}</td>
              <td>{{size.artwork | size | inches }}</td>
              <td>{{ size.opening | size | inches }}</td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
  @if (!showOpeningSizes) {
    <mat-form-field>
      <mat-label>Standard Sizes</mat-label>
      <mat-select (selectionChange)="onStandardSizeDropDownChange($event)">
        @for (size of availableSizes; track size) {
          <mat-option [value]="size">
            {{size.outer | size | inches }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

